import en from "./en"
import pt from "./pt"
import es from "./es"

export default {
  en,
  pt,
  es
}